import React from "react";
import { ServicesCard, ServicesContainer, ServicesH1, ServicesH2, ServicesIcon, ServicesP, ServicesWrapper } from "./ServicesElements";


export const Services = ({ title, cards }) => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>{title}</ServicesH1>
      <ServicesWrapper>
        {cards.map((card, index) => (
          <ServicesCard key={index}>
            <ServicesIcon src={card.icon} />
            <ServicesH2>{card.title}</ServicesH2>
            <ServicesP>{card.description}</ServicesP>
          </ServicesCard>
        ))}
      </ServicesWrapper>
    </ServicesContainer>
  );
};
